import MentoringPrograms from 'athena/components/mentoring-programs';

/* @ngInject */
export default function MentoringProgramsController(
  $scope,
) {
  $scope.MentoringPrograms = MentoringPrograms;
}
